import Button from 'components/Button';
import {format} from 'date-fns';
import {FC, useContext} from 'react';
import {useLocale} from 'state/locale';
import {twMerge} from 'tailwind-merge';
import {Locale} from 'types';

import DateSelectContext from '../../context';

export const getMonthDateString = (date: Date, locale: Locale): string => {
    if (locale === 'en') {
        return `${format(date, 'MMMM')} ${format(date, 'y')}`;
    }

    return `${format(date, 'y')}年${format(date, 'M')}月`;
};

const DateSelectMonth: FC = () => {
    const {
        id,
        isNextDisabled,
        isPreviousDisabled,
        onNext,
        onPrevious,
        visibleDateZonedAtJst,
    } = useContext(DateSelectContext);

    const locale = useLocale();

    return (
        <div className="flex items-center justify-between text-sm">
            <Button
                aria-label="Previous Month"
                className={twMerge(
                    isPreviousDisabled
                        ? 'cursor-not-allowed text-light-disabled'
                        : 'cursor-pointer text-light-primary',
                )}
                disabled={isPreviousDisabled}
                icon="arrow_left"
                id={`${id}-date-selector-nav-previous`}
                kind="tertiary"
                onClick={onPrevious}
                size="xs"
                tabIndex={0}
            />
            <div
                aria-level={1}
                className="m-1 flex h-4 flex-1 items-center justify-center font-semibold"
                role="heading"
            >
                {getMonthDateString(visibleDateZonedAtJst, locale)}
            </div>
            <Button
                aria-label="Next Month"
                className={twMerge(
                    isNextDisabled
                        ? 'cursor-not-allowed text-light-disabled'
                        : 'cursor-pointer text-light-primary',
                )}
                disabled={isNextDisabled}
                icon="arrow_right"
                id={`${id}-date-selector-nav-next`}
                kind="tertiary"
                onClick={onNext}
                size="xs"
                tabIndex={0}
            />
        </div>
    );
};

export default DateSelectMonth;
